import styled, { css } from 'styled-components';

import { Modal } from '@speeki/global-ui-components';
import { Typography } from '@speeki/global-ui-components';
import { IconButton } from '@speeki/icons';

export const ModalContent = styled(Modal.Content)(
    ({ theme: { radius } }) => css`
        border-radius: ${radius[8]}px;
    `,
);

export const CloseButton = styled(IconButton)`
    position: absolute;
    right: 12px;
    top: 12px;
`;

export const DetailsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const DetailsName = styled(Typography.TextBody_14_24)(
    ({ theme: { palette } }) => css`
        color: ${palette.text.assistive};
    `,
);
